import { IndexCardStack } from './index-card-stack';
import { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { StiiizyStrainIndexCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/index-cards-3x5/stiiizy-strain-index-card-stack-content/stiiizy-strain-index-card-stack-content.component';

export class StiiizyStrainIndexCardStack extends IndexCardStack {
  getCardHeightInInches(): number {
    return 3.08;
  }

  getCardWidthInInches(): number {
    return 5.12;
  }

  getCardBackgroundComponent(data: CardData): Type<CardBackgroundComponent> | null {
    // artificial white border around card, so background is included within content component
    return null;
  }

  getCardContentComponent(data: CardData): Type<PrintCardContentComponent> | null {
    return StiiizyStrainIndexCardStackContentComponent;
  }

  nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
